module.exports = __webpack_public_path__ + "img/lv.11e8ea63.svg";